<template>
  <footer class="ctype__footnotes">
    <small v-html="content.markup"></small>
  </footer>
</template>

<script>
  export default {
    name: 'Footnotes',
    props: {
      content:{
        type: Object,
        required: true
      }
    }
  }
</script>

<style src="./Footnotes.scss" lang="scss"></style>
